var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modal",attrs:{"showModal":_vm.hasModalAddressEdit,"title":"Editar endereço"},on:{"close":_vm.closeModalEdit},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('address-modal-form',{attrs:{"data":_vm.formattedAddressData,"mutation":"get","sellerType":_vm.dataSellerType}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }